import type { Sensor } from '../types/domain'
import { dateTime } from './format'
import { StatusBadge } from './StatusBadge'

export function SensorsView({ sensors }: { sensors: Sensor[] }) {
  return (
    <section className="page-section">
      <div className="section-heading"><div><p className="eyebrow">Реестр оборудования</p><h1>Датчики</h1></div><p className="section-note">{sensors.length} устройств · калибровка хранится на сервере</p></div>
      <div className="card table-card sensors-table">
        <div className="table-scroll">
          <table>
            <thead><tr><th>Датчик</th><th>Модель / прошивка</th><th>Статус</th><th>Батарея</th><th>Последний контакт</th></tr></thead>
            <tbody>{sensors.map(sensor => (
              <tr key={sensor.id}>
                <td data-label="Датчик"><strong>{sensor.serialNumber}</strong><small>{sensor.bleId}</small></td>
                <td data-label="Модель / прошивка">{sensor.model}<small>{sensor.firmwareVersion ?? '—'}</small></td>
                <td data-label="Статус"><StatusBadge status={sensor.status} /></td>
                <td data-label="Батарея"><span className={sensor.batteryPercent !== undefined && sensor.batteryPercent < 20 ? 'danger-text' : ''}>{sensor.batteryPercent ?? '—'}%</span></td>
                <td data-label="Последний контакт">{dateTime(sensor.lastSeenAt)}</td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      </div>
    </section>
  )
}
